import React from 'react'
import {
  TableHeaderCounterMaxNumOfDomains,
  TableHeaderCounterNumOfDomains,
  TableHeaderCounterStyled,
  TableHeaderCounterTitle,
} from 'Features/domainsManagement/components/TableHeaderCounter/TableHeaderStyled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { theme, Tooltip } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'

type TableHeaderCounterProps = {
  title: string
  numOfDomains: number
  maxNumOfDomains: number
}

export const TableHeaderCounter = ({
  title,
  numOfDomains,
  maxNumOfDomains,
}: TableHeaderCounterProps) => {
  const { t } = useTranslation('domainManagement')
  const approachingLimit = maxNumOfDomains - 1 === numOfDomains
  const reachedLimit = maxNumOfDomains === numOfDomains
  return (
    <TableHeaderCounterStyled>
      <TableHeaderCounterTitle>{title}</TableHeaderCounterTitle>
      {(approachingLimit || reachedLimit) && (
        <Tooltip
          tooltiptContent={
            approachingLimit
              ? t('approaching_product_limit', { product: title })
              : t('product_limit_reached', { product: title })
          }
        >
          <FontAwesomeIcon
            style={{
              color: theme.colors.accentLight.value,
              margin: '1px 3px 0px 0px',
              width: '16px',
            }}
            icon={faTriangleExclamation as IconProp}
          />
        </Tooltip>
      )}
      <TableHeaderCounterNumOfDomains>{numOfDomains}</TableHeaderCounterNumOfDomains>
      <TableHeaderCounterMaxNumOfDomains>/{maxNumOfDomains}</TableHeaderCounterMaxNumOfDomains>
    </TableHeaderCounterStyled>
  )
}
